module.exports = __webpack_public_path__ + "img/rwanda.a643bb73.svg";